export const NAME_STORAGE = {
  ACCESS_TOKEN: "access_token",
  USER: "user",
};
